/**
*@title 엑스포 소개
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';

import Video from './Video'

import contItem01 from '../../images/cont_item_01_2022.svg';
import { FaDna } from "react-icons/fa";
import { t } from 'i18next';

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

import expo_overview from "../../images/exhibition_overview_1.svg";
import expo_overview_en from "../../images/exhibition_overview_1_en.svg";

const Review = () => {
    return(
        <div>
            <div>
                <div className="sect-01-box-01-review w-full lg:w-3/4 md:w-10/12 mx-auto">
                    <div className="sect-01-img-01"><img src={contItem01}/></div>
                    <div className="sect-01-tit-01">{t("review_title")}</div>
                    <div className="sect-01-txt-01">
                        {t("review_context1")}<br/>{t("review_context2")}
                    
                        <br/><br/>
                        <i><FaDna/></i> {t("review_summary1")}
                        <br/>
                        <i><FaDna/></i> {t("review_summary2")}
                        <br/>
                        <i><FaDna/></i> {t("review_summary3")}
                        <br/>
                        <i><FaDna/></i> {t("review_summary4")}
                        <div>
                        {/* {t("lang") === "ko"
                            ?<img src={expo_overview} />
                            :<img src={expo_overview_en} />
                        } */}
                        </div>
                    </div>
                    <Video/>
                </div>
            </div>
            {/* <section> */}
            
            {/* <div className="sect-01-vod-box">
                <iframe src="https://www.youtube.com/embed/RQOQYTZSedg" title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
            </div> */}
        {/* </section> */}
        </div>
    )
}

export default Review;